// WARNING: This exists to provide a functionally compliant t and Trans component.
// Given we do not need to support translations at this time, we are not using the i18n library.
// export * from './use-i81n-translation';

import useTranslation from './pass-through-translation';

export * from './pass-through-translation';

export default useTranslation;
